import React, {Suspense, lazy, useEffect} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {CssBaseline, CircularProgress, Box} from '@mui/material';
import ScrollToTop from '../utils/ScrollToTop';
import FullscreenMenu from './FullscreenMenu';
import Footer from './Footer';
import GoogleAnalytics from '../GoogleAnalytics';
import ViewProjectPage from '../pages/Project/ViewProjectPage';

const AboutPage = lazy(() => import('../pages/About/AboutPage'));
const CareersPage = lazy(() => import('../pages/Careers/CareersPage'));
const ContactPage = lazy(() => import('../pages/Contact/ContactPage'));
const CookiePolicyPage = lazy(() => import('../pages/CookiePolicy/CookiePolicyPage'));
const IntegrityPolicyPage = lazy(() => import('../pages/IntegrityPolicy/IntegrityPolicyPage'));
const PostsPage = lazy(() => import('../pages/News/PostsPage'));
const ServicesPage = lazy(() => import('../pages/Services/ServicesPage'));
const ProjectsPage = lazy(() => import('../pages/Project/ProjectsPage'));
const StartPage = lazy(() => import('../pages/Start/StartPage'));
const LoginPage = lazy(() => import('../pages/Login/LoginPage'));
const EditPostPage = lazy(() => import('../pages/News/EditPostPage'));
const EditProjectPage = lazy(() => import('../pages/Project/EditProjectPage'));
const ViewJobDetailPage = lazy(() => import('../pages/Careers/ViewJobDetailPage'));
const ViewPostPage = lazy(() => import('../pages/News/ViewPostPage'));
const ContactsPage = lazy(() => import('../pages/Contacts/ContactsPage'));
const EditServicePage = lazy(() => import('../pages/Services/EditServicePage'));
const ViewServicePage = lazy(() => import('../pages/Services/ViewServicePage'));
const IntranetPage = lazy(() => import('../pages/Intranet/IntranetPage'));
const ViewInternalPostPage = lazy(() => import('../pages/Intranet/ViewInternalPostPage'));
const EditInternalPostPage = lazy(() => import('../pages/Intranet/EditInternalPostPage'));
const NotfoundPage = lazy(() => import('../pages/NotfoundPage'));

const RouteLoadingFallback = () => (
	<Box
		sx={{
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			minHeight: '60vh',
		}}
	>
		<CircularProgress sx={{color: '#4cae52'}} />
	</Box>
);

export const Main = () => {
	useEffect(() => {
		import('../pages/Project/ProjectsPage');
		import('../pages/Start/StartPage');
	}, []);

	return (
		<BrowserRouter>
			<ScrollToTop />
			<CssBaseline />
			<FullscreenMenu />
			<Suspense fallback={<RouteLoadingFallback />}>
				<Switch>
					<Route path="/cookiepolicy" component={CookiePolicyPage} />
					<Route path="/integritetspolicy" component={IntegrityPolicyPage} />
					<Route path="/login" component={LoginPage} />

					<Route path="/om-oss" component={AboutPage} />
					<Route path="/karriär" component={CareersPage} />
					<Route path="/ledigajobb/:job_id" component={ViewJobDetailPage} />
					<Route exact path="/kontakt" component={ContactsPage} />
					<Route path="/kontakt/:email" component={ContactPage} />

					<Route exact path="/nyheter" component={PostsPage} />
					<Route path="/nyheter/:post_id" component={ViewPostPage} />
					<Route path="/redigeranyhet/:post_id" component={EditPostPage} />

					<Route exact path="/internwebb" component={IntranetPage} />
					<Route path="/internwebb/:post_id" component={ViewInternalPostPage} />
					<Route path="/editinternal/:post_id" component={EditInternalPostPage} />

					<Route exact path="/tjänster" component={ServicesPage} />
					<Route path="/services/:item_id" component={EditServicePage} />
					<Route path="/tjänster/:url" component={ViewServicePage} />

					<Route exact path="/projekt" component={ProjectsPage} />
					<Route path="/projects/:project_id" component={EditProjectPage} />
					<Route path="/projekt/:url" component={ViewProjectPage} />

					<Route exact path="/" component={StartPage} />
					<Route component={NotfoundPage} />
				</Switch>
			</Suspense>
			<GoogleAnalytics />
			<Footer />
		</BrowserRouter>
	);
};

export default Main;
